export default __webpack_public_path__ + "static/media/jquery.713ace68.svg";